import type { Selector, State as S } from 'model/State';

// Not a progress anymore because it's a result of a progress via ifSuccess. Also could be a null
export const selectIsBtfAlreadyUsedForCMT: Selector<string | boolean | null> = (state: S) =>
  state.mac.btfAccountId.isBtfAlreadyUsedForCMT?.ifSuccess((r) => r);

export const selectManageAppLinkForBtfUnderCmt: Selector<string | null> = (state: S) =>
  state.mac.btfAccountId.manageAppLinkForBtfUnderCmt?.ifSuccess((r) => r);

export const selectSiteNameWithDomainForBtfUnderCmt: Selector<string | null> = (state) =>
  state.mac.btfAccountId.siteNameWithDomainForBtfUnderCmt.ifSuccess((r) => r);
